import { createLucideIcon } from 'lucide-react'
import type { RaceGender } from '@/lib/watch/graphics'

/**
 * Venus and Mars: a board or a place within women or men (design/DESIGN.md, Icons over words). Lucide's own paths, drawn
 * with its `createLucideIcon` so they match the set, because the Lucide we pin (0.460) predates them; switch to Lucide's
 * exports once it is upgraded.
 */
export const Venus = createLucideIcon('Venus', [
  ['path', { d: 'M12 15v7', key: 'venus-stem' }],
  ['path', { d: 'M9 19h6', key: 'venus-bar' }],
  ['circle', { cx: '12', cy: '9', r: '6', key: 'venus-ring' }],
])

export const Mars = createLucideIcon('Mars', [
  ['path', { d: 'M16 3h5v5', key: 'mars-head' }],
  ['path', { d: 'm21 3-6.75 6.75', key: 'mars-shaft' }],
  ['circle', { cx: '10', cy: '14', r: '6', key: 'mars-ring' }],
])

export const GENDER_GLYPH: Record<RaceGender, typeof Venus> = { female: Venus, male: Mars }
